<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body images">
        <hr class="image_hr">
        <div class="doc-tabs">
            <div class="doc-grid h-100 d-flex flex-column position-relative">
              <app-ag-grid 
              [style.height]="'18rem'"
                [columnSettings]="false"
                [paginations]="false" 
                [getRowStyle]="getRowStyle"
                [dataModel]="AgGridDataModel"
                (gridReady)="onGridReady($event)" 
                (onPagination)="onPagination($event)" 
                (onSelectionChange)="onSelectionChange($event)">
              </app-ag-grid>
            </div>
          </div>
  
     </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class=" m-0 d-flex gap-3">
            <app-button [buttonType]="'button'" [button_2]="true"
                [ngClass]="{'cursor-not-allowed':data?.editable}"
                [buttonClass]="selectedData?.length > 0 && !data?.editable ? 'button-danger button popup-button' : 'button-info button popup-button'" class=""
                (click)="selectedData?.length > 0 ? deleteRow():''" [buttonLable]="enumButtonName.DELETE"></app-button>
            <app-button [buttonType]="'button'" [button_2]="true"
                [buttonClass]="false ? 'button-primary button  popup-button' : 'button-info button  popup-button  popup-button'" class=""
                [buttonLable]="enumButtonName.CANCEL" (click)="activeModal.close({data:data,confirm:true})"></app-button>
            <app-button [buttonType]="'button'" [button_2]="true"
                [ngClass]="{'cursor-not-allowed':data?.editable}"
                [buttonClass]="true ? 'button-primary button popup-button' : 'button-info button popup-button'" class=""
                [buttonLable]="'Upload'" (click)="data?.editable?'': openUploadImagesPopup()"></app-button>
        </div>
    </div>
</div>